@if (buttonType() === 'link' && externalLink()) {
  <a
    [attr.id]="buttonId()"
    [href]="href()"
    target="_blank"
    rel="noopener"
    [ngClass]="classes()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled() || isLoading() || null"
    [attr.tabindex]="(disabled() || isLoading()) ? -1 : null"
  >
    {{ text() }}<ng-content></ng-content>
  </a>
} @else if (buttonType() === 'link') {
  <a
    [attr.id]="buttonId()"
    [routerLink]="routerLink()"
    [queryParams]="queryParams()"
    [ngClass]="classes()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled() || isLoading() || null"
    [attr.tabindex]="(disabled() || isLoading()) ? -1 : null"
  >
    {{ text() }}<ng-content></ng-content>
  </a>
} @else {
  <button
    [attr.id]="buttonId()"
    [type]="type()"
    [disabled]="disabled() || isLoading()"
    [ngClass]="classes()"
    [attr.aria-label]="ariaLabel()"
  >
    {{ text() }}<ng-content></ng-content>
  </button>
}
